const statusStyleMap = {
    COM018_10: { backgroundColor: '#FFF8E1', color: '#FFC107', fontSize: '12px' },
    COM018_20: { backgroundColor: '#E3E8EF', color: '#2196F3', fontSize: '12px' },
    COM018_30: { backgroundColor: '#B9F6CA', color: '#00C853', fontSize: '12px' },
    COM018_40: { backgroundColor: '#FBE9E7', color: '#D84315', fontSize: '12px' },
    COM018_50: { backgroundColor: '#FBE9E7', color: '#D84315', fontSize: '12px' },
    ANN010_1: { backgroundColor: '#FFF8E1', color: '#FFC107', fontSize: '12px' },
    ANN010_2: { backgroundColor: '#B9F6CA', color: '#00C853', fontSize: '12px' },
    COM020_1: { backgroundColor: '#FFF8E1', color: '#FFC107', fontSize: '12px' },
    COM020_2: { backgroundColor: '#B9F6CA', color: '#00C853', fontSize: '12px' },
    COM020_3: { backgroundColor: '#FBE9E7', color: '#D84315', fontSize: '12px' },
    COM020_9: { backgroundColor: '#E3E8EF', color: '#2196F3', fontSize: '12px' }
};

const resultStyleMap = {
    COM019_1: { backgroundColor: '#E3E8EF', color: '#2196F3', fontSize: '12px' },
    COM019_2: { backgroundColor: '#FFF8E1', color: '#FFC107', fontSize: '12px' }
};

export { resultStyleMap };
export default statusStyleMap;
